// CommentsPage.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Button, Form, Nav } from 'react-bootstrap';
import Navbar from '../../../../Shared/AdminNavbar/Navbar';
import baseURL from '../../../../Apiurs/Apiurls';
import './CommentsPage.css';
import "../../../../Layout/Collapse/Collapse.css";

const A_LeadsCommentsPage = () => {
  const { leadid } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const [assignedSalesId, setAssignedSalesId] = useState(null);
  const [email, setEmail] = useState(null);
  const [managerid, setManagerId] = useState(null);
  const themeColor = "#007bff";

  // Detect current path for active tab
  const path = location.pathname;
  const isOpportunity = path.includes("/a-opp-");
  const isCommentsActive = path.includes("comments");
  const isFollowupActive = path.includes("followup");

  // Fetch comments
  useEffect(() => {
    const fetchComments = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/comments/${leadid}`);
        const sortedComments = response.data.sort(
          (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
        );
        setComments(sortedComments);
      } catch (error) {
        console.error("Error fetching comments:", error);
      }
    };
    fetchComments();
  }, [leadid]);

  // Fetch lead details
  useEffect(() => {
    const fetchLeadDetails = async () => {
      try {
        const leadResponse = await axios.get(`${baseURL}/api/leads/${leadid}`);
        setAssignedSalesId(leadResponse.data.assignedSalesId);
        setManagerId(leadResponse.data.managerid);
        setEmail(leadResponse.data.email);
      } catch (error) {
        console.error("Error fetching lead details:", error);
      }
    };
    fetchLeadDetails();
  }, [leadid]);

  // Add a new comment
  const handleAddComment = async () => {
    if (!newComment.trim()) return;

    const trimmedComment = newComment.trim();
    const commentName = "Admin";

    const comment = {
      name: commentName,
      leadid: leadid,
      timestamp: new Date().toISOString(),
      text: trimmedComment,
      notificationmessage: `${commentName}:${trimmedComment}  `,
      managerId: managerid,
      userId: assignedSalesId,
      email: null
    };

    try {
      const commenturl = `${baseURL}/api/comments/add`;
      const response = await fetch(commenturl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(comment),
      });

      if (response.ok) {
        const addedComment = await response.json();
        setComments((prevComments) => [...prevComments, addedComment]);
        setNewComment("");
      } else {
        console.error("Failed to add comment");
      }
    } catch (error) {
      console.error("Error adding comment:", error);
    }
  };

  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>

        {/* 🔹 Nav Tabs */}
        <div className="d-flex justify-content-start" style={{ marginLeft: "5%", marginBottom: "15px" }}>
          <Nav variant="tabs">
            <Nav.Item>
              <Nav.Link
                active={isCommentsActive}
                onClick={() => {
                  if (isOpportunity) {
                    navigate(`/a-opp-comments/${leadid}`);
                  } else {
                    navigate(`/a-comments/${leadid}`);
                  }
                }}
                style={{
                  color: isCommentsActive ? themeColor : "black",
                  fontWeight: isCommentsActive ? "bold" : "normal"
                }}
              >
                Comments
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                active={isFollowupActive}
                onClick={() => {
                  if (isOpportunity) {
                    navigate(`/a-opp-followup/${leadid}`);
                  } else {
                    navigate(`/a-followup/${leadid}`);
                  }
                }}
                style={{
                  color: isFollowupActive ? themeColor : "black",
                  fontWeight: isFollowupActive ? "bold" : "normal"
                }}
              >
                Follow Up
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>

        {/* 🔹 Comment Form */}
        <div className="comment-form-container">
          <h3 className='comment-form-header' style={{ "--theme-color": themeColor }}>Comments</h3>

          <div className="mb-3 opp-modal-footer">
            <Form.Group>
              <Form.Label>Add a New Comment</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                type="text"
                placeholder="Write your comment here..."
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                autoFocus
              />
              <Button
                className="mt-2 opp-comment-btn-primary"
                onClick={handleAddComment}
                disabled={!newComment.trim()}
              >
                Add Comment
              </Button>
            </Form.Group>
          </div>

          {/* 🔹 Comment List */}
          <div style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #ddd", padding: "10px", borderRadius: "5px" }}>
            {[...comments]
              .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
              .map((comment, index) => (
                <div key={index} className="mb-3">
                  <p style={{ fontSize: "13px", color: "gray" }}>
                    {new Date(comment.timestamp).toLocaleString("en-IN", {
                      timeZone: "Asia/Kolkata",
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true,
                    })}
                  </p>
                  <p>
                    <strong>{comment.name}</strong>:  
                    <span style={{ whiteSpace: "pre-line" }}>{comment.text}</span>
                  </p>
                </div>
              ))}
          </div>

          <div className="mt-3">
            <Button className="comment-close-btn comment-btn" onClick={() => navigate(-1)}>
              Back
            </Button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default A_LeadsCommentsPage;
